import { Box, Button } from '@mui/material';

const NextButton = ({
   checkedIn,
   host,
   checkout,
   handleSubmit,
   alertHost,
   confirmed,
   setConfirmed,
   customisations,
   confirmationStatementCheckbox,
}) => {
   async function handleNextButton() {
      if (checkedIn) {
         return checkout();
      } else if (
         host?.found &&
         customisations?.confirmationStatements?.length > 0 &&
         confirmationStatementCheckbox &&
         !confirmed
      ) {
         setConfirmed(true);
         return;
      } else if (host?.found) {
         return alertHost();
      } else {
         return handleSubmit();
      }
   }
   return (
      <Box sx={{ width: '15%', mt: 2, display: 'flex', alignItems: 'flex-start' }}>
         {console.log(confirmed, 'confirmed')}
         <Button
            onClick={handleNextButton}
            sx={{ height: '130px' }}
            fullWidth
            variant="contained"
            color="primary"
            disabled={
               host?.found && !confirmed && !checkedIn && !confirmationStatementCheckbox
            }
         >
            {checkedIn ? 'Check out' : host?.found ? 'Submit' : 'Next'}
         </Button>
      </Box>
   );
};

export default NextButton;
